import { eachDayOfInterval, format, getISODay, parseISO } from 'date-fns'

import { CalendarGridItemVariant } from '../../../constants/calendarGrid'
import { EMPTY_LIST } from '../../../constants/common'
import { DATE_API_DATA_FORMAT_SHORT } from '../../../constants/date'
import { createDate } from '../../../utils/date'

const CALENDAR_GRIDS_MOCK_ITEMS = [
  {
    end: '10:00',
    secondaryLabel: 'Top 3, Teststraße 1',
    start: '09:00',
    title: 'Wohnungsbesichtigung',
    variant: CalendarGridItemVariant.brand,
    weekday: 1,
  },
  {
    end: '10:30',
    secondaryLabel: 'Anna Schmidt',
    start: '10:00',
    title: 'Besichtigung',
    variant: CalendarGridItemVariant.brand,
    weekday: 2,
  },
  {
    end: '10:30',
    secondaryLabel: 'Julia Bergmann',
    start: '10:00',
    title: 'Besichtigung',
    variant: CalendarGridItemVariant.brand,
    weekday: 2,
  },
  {
    end: '10:30',
    secondaryLabel: 'Top 7, Teststraße 1',
    start: '10:00',
    title: 'Übergabe',
    variant: CalendarGridItemVariant.gold,
    weekday: 2,
  },
  {
    end: '11:30',
    start: '11:00',
    title: 'Freier Termin',
    tooltip: 'Termin buchen',
    variant: CalendarGridItemVariant.free,
    weekday: 3,
  },
  {
    end: '15:00',
    secondaryLabel: 'Top 12, Teststraße 1',
    start: '14:00',
    title: 'Abnahme',
    variant: CalendarGridItemVariant.green,
    weekday: 4,
  },
  {
    secondaryLabel: 'Teststraße 1',
    title: 'Hausversammlung',
    variant: CalendarGridItemVariant.brand,
    weekday: 5,
  },
  {
    end: '08:30',
    secondaryLabel: 'Sophie Lechner',
    start: '08:00',
    title: 'Abgesagt',
    variant: CalendarGridItemVariant.muted,
    weekday: 6,
  },
]

function getCalendarGridsMockTime({ day, time, timezone }) {
  const [hours, minutes] = time?.split(':').map(Number) ?? EMPTY_LIST

  return time
    ? createDate(
        timezone,
        day.getFullYear(),
        day.getMonth(),
        day.getDate(),
        hours,
        minutes
      ).toISOString()
    : null
}

function getIsCalendarGridsMockItemOnDay({ day, item }) {
  return item.weekday === getISODay(day)
}

function toCalendarGridsMockItem({ date, day, index, item, timezone }) {
  return {
    ...item,
    date,
    end: getCalendarGridsMockTime({ day, time: item.end, timezone }),
    id: `${date}-${index}`,
    isAllDay: !item.start,
    start: getCalendarGridsMockTime({ day, time: item.start, timezone }),
  }
}

export async function getCalendarGridsMockItems({ from, timezone, to }) {
  return eachDayOfInterval({
    end: parseISO(to),
    start: parseISO(from),
  }).flatMap(day =>
    CALENDAR_GRIDS_MOCK_ITEMS.filter(item =>
      getIsCalendarGridsMockItemOnDay({ day, item })
    ).map((item, index) =>
      toCalendarGridsMockItem({
        date: format(day, DATE_API_DATA_FORMAT_SHORT),
        day,
        index,
        item,
        timezone,
      })
    )
  )
}
